import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Home2 from '../views/Home2.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/free',
    name: 'Home2',
    component: Home2
  },
  {
    path: '/warrick',
    name: 'warrick',
    component: () => import(/* webpackChunkName: "about" */ '../views/Warrick.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
